export default __webpack_public_path__ + "static/media/07-min.ae65b119.jpg";